import { get, isEmpty } from 'lodash';
import { getReferralCode } from './localStorage';

export const CURRENT_CAMPAIGNS = {
  staging: ['MF3fd783141f', 'MFc6b1193586'],
  production: ['MF41de858d1a', 'MF8982b8b773'],
};

/**
 * Get all ReferralHero campaign keys from window object
 * @returns {string[]} Array of campaign keys (e.g., ['RH_MF41de858d1a', 'RH_MF8982b8b773'])
 */
export const RHCampaigns = () => {
  return Object.keys(window).filter(key => {
    return key.toString().startsWith('RH_');
  });
};

/**
 * Find the current active ReferralHero campaign
 * Prioritizes campaigns that have a referrer set
 *
 * @param {string[]} campaigns - Array of campaign keys
 * @returns {string|undefined} The current campaign key or undefined
 */
export const RHCurrentCampaign = campaigns => {
  return campaigns.find(c => {
    const campaign = get(window, c, {});
    return !isEmpty(campaign.referrer);
  });
};

/**
 * Find the ReferralHero campaign that matches a specific referral code
 *
 * @param {string} mwrCode - The mwr/referral code to match
 * @returns {Object|null} The matching campaign object or null
 */
export const findCampaignByMwr = mwrCode => {
  if (!mwrCode) return null;

  const campaigns = RHCampaigns();

  for (const campaignKey of campaigns) {
    const campaign = get(window, campaignKey, null);
    if (campaign && campaign.referrer === mwrCode) {
      return campaign;
    }
  }

  return null;
};

/**
 * Get the referral code with fallback strategy:
 * 1. Try localStorage (most reliable - captured from URL)
 * 2. Try ReferralHero window object (fallback for existing campaigns)
 *
 * @returns {string|null} The referral code or null
 */
export const getReferralCodeWithFallback = (location = {}) => {
  // First, try get mwr params from url (most reliable)
  if (!isEmpty(location)) {
    const params = new URLSearchParams(get(location, 'search', ''));

    if (params.get('mwr')) {
      return params.get('mwr');
    }
  }

  // Second, try localStorage
  const storedCode = getReferralCode();
  if (storedCode) {
    return storedCode;
  }

  // Fallback: Try to get from ReferralHero window object
  const campaigns = RHCampaigns();
  const currentCampaign = RHCurrentCampaign(campaigns);
  if (currentCampaign) {
    const RHCampaign = get(window, currentCampaign, null);
    return RHCampaign ? get(RHCampaign, 'referrer', null) : null;
  }

  return null;
};
